import(/* webpackMode: "eager" */ "/mnt/volume-nbg1-1/apps/bookie/frontend/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Geist\",\"arguments\":[{\"variable\":\"--font-geist-sans\",\"subsets\":[\"latin\"]}],\"variableName\":\"geistSans\"}");
;
import(/* webpackMode: "eager" */ "/mnt/volume-nbg1-1/apps/bookie/frontend/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Geist_Mono\",\"arguments\":[{\"variable\":\"--font-geist-mono\",\"subsets\":[\"latin\"]}],\"variableName\":\"geistMono\"}");
;
import(/* webpackMode: "eager" */ "/mnt/volume-nbg1-1/apps/bookie/frontend/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/mnt/volume-nbg1-1/apps/bookie/frontend/src/components/app-initial-loader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/mnt/volume-nbg1-1/apps/bookie/frontend/src/components/DynamicTitle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/mnt/volume-nbg1-1/apps/bookie/frontend/src/components/I18nProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/mnt/volume-nbg1-1/apps/bookie/frontend/src/components/ThemeInitializer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/mnt/volume-nbg1-1/apps/bookie/frontend/src/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/mnt/volume-nbg1-1/apps/bookie/frontend/src/contexts/AuthProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ConfigProvider"] */ "/mnt/volume-nbg1-1/apps/bookie/frontend/src/contexts/ConfigContext.tsx");
